import ServiceBase from "@app/shared/serviceBase";
import { PatternOfCareProviderModel, PatternOfCareProviderLookupSearchModel, PatternOfCareProviderSpecialtyModel, AppendedPatternOfCareProviderModel, RemoveAppendedPatternOfCareProviderModel } from "./interfaces";

export default class PatternOfCareProvidersService extends ServiceBase {
  private readonly root = "/patternOfCareProviders";
  public async providerLookup(projectId: number, runConfigurationId: number, regionSetId: number, specialtyGroupCode: string, searchModel: PatternOfCareProviderLookupSearchModel): Promise<PatternOfCareProviderModel[]> {
    return await this.makePost(`${this.root}/provider-lookup/custom-projects/${projectId}/project-run-configurations/${runConfigurationId}/region-sets/${regionSetId}?specialtyGroupCode=${specialtyGroupCode}`, searchModel);
  }

  public async appendProviders(providerSpecialtyModels: PatternOfCareProviderSpecialtyModel[], projectId: number, runConfigurationId: number, regionSetId: number, specialtyGroupCode: string): Promise<void> {
    return await this.makePost(`${this.root}/append-providers/custom-projects/${projectId}/project-run-configurations/${runConfigurationId}/region-sets/${regionSetId}?specialtyGroupCode=${specialtyGroupCode}`, providerSpecialtyModels);
  }

  public async getAppendedProviders(projectId: number, runConfigurationId: number, regionSetId: number, specialtyGroupCode: string): Promise<AppendedPatternOfCareProviderModel[]> {
    return await this.makeGet(`${this.root}/appended-providers/custom-projects/${projectId}/project-run-configurations/${runConfigurationId}/region-sets/${regionSetId}?specialtyGroupCode=${specialtyGroupCode}`);
  }

  public async removeAppendedProviders(appendedProviderIds: number[], projectId: number): Promise<void> {
    const removeAppendedPatternOfCareProvider: RemoveAppendedPatternOfCareProviderModel = {
      appendedPatternOfCareProviderIds: appendedProviderIds
    };

    return await this.makeDelete(`${this.root}/remove-appended-providers/custom-projects/${projectId}`, removeAppendedPatternOfCareProvider);
  }
}
